import { Datepicker, MbscCalendarEvent } from "@mobiscroll/react";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { ToastConfig } from "../../components/Toaster";
import { UpdateGoalRequest } from "pgi-experience-client";
import { createWorkflowApi } from "../../api-helpers/CommonUtilsApiHelper";
import { createPgiApi } from "../../api-helpers/PgiApiHelper";
import { WorkflowStateWithNextState, WorkflowState } from "common-util-experience-client";
import { WorkflowConstants } from "../../helper/WorkflowConstants";
import { formatDateTask } from "../../helper/dateFormatter";
import { PatientGoals } from "grid-experience-client";


export interface GoalProps {
  selectedGoal?: PatientGoals;
  onUpdateGoal: (toasterConfig: ToastConfig) => Promise<void>;
  setOffCanvasShow: React.Dispatch<React.SetStateAction<boolean>>;
  loadPgis: () => void;
}

export const EditGoal = (props: GoalProps) => {
  const [validated, setValidated] = useState(false);
  const [date, setDate] = useState<Date | null>(null);
  const [workflowStatus, setWorkflowStatus] = useState<WorkflowState[]>();
  const [openPicker, setOpenPicker] = useState<boolean>(false);

const initialGoalForm: UpdateGoalRequest = {
  dueDate: props.selectedGoal?.dueDate || new Date(),
  status: props.selectedGoal?.goalDesignerStateId || '',
  goalComment: "",
};

  const [goalForm, setGoalForm] = useState<UpdateGoalRequest>(initialGoalForm);
  const handleUpdateGoal = (
    e:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setGoalForm({
      ...goalForm,
     [ e.target.name]: e.target.value,
    });
  };

  const dateRangeChangeHandlar = (event: MbscCalendarEvent) => {
    const { name, value } = event;
    if(!value || value < goalForm.dueDate) return; 
    const selectedDate = new Date(value);
    const utcDate = new Date(
      Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
      )
    );
    setGoalForm({ ...goalForm, dueDate: utcDate });
  };
  const handleDiscard = () => {
    props.setOffCanvasShow(false);
  };

  const pgiApi = createPgiApi();
  const workflow = createWorkflowApi();

  const updateGoal = async () => {
      if(props.selectedGoal?.patientGoalId)  {
        const updatedPayload = {
          ...goalForm,
        };
        await pgiApi.pgiControllerUpdateGoal(updatedPayload, props.selectedGoal?.patientGoalId);
      }
  };

  const getWorkflowStatus = async () => {
    try {
    const workflowStatusResponse = await workflow.workflowControllerGetStatesForWorkflow(WorkflowConstants.goal);
    setWorkflowStatus((await workflowStatusResponse).data);
      console.log("Workflow Status : " + workflowStatus);
    } catch (error) {
      console.error("Error fetching workflow status : " + error);
    }
  };

  useEffect(() => {
    setGoalForm({
      dueDate: props.selectedGoal?.dueDate || new Date(),
      status: props.selectedGoal?.goalDesignerStateId || '',
      goalComment: "",
    })
    getWorkflowStatus();
    console.log("selected goal", props.selectedGoal);
  }, []);

  const updateGoalHandler = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setValidated(true);

    if(!goalForm.dueDate) return;

    const form = event.currentTarget;
    console.log('update goal form : ', goalForm)
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    try {
      await updateGoal();
      const toasterConfig = {
        type: "success",
        title: "Goal updated successfully!",
        icon: "check_circle_outline",
      };
      props.onUpdateGoal(toasterConfig as ToastConfig);
      props.loadPgis();
      handleDiscard()
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message?.message;
      const toasterConfig = {
        type: "danger",
        title: errorMessage,
        icon: "error_outline",
      };
      props.onUpdateGoal(toasterConfig as ToastConfig);
    }
  };

  return (
    <Form
      className="d-flex flex-column h-100"
      noValidate
      validated={validated}
      onSubmit={(e) => updateGoalHandler(e)}
    >
      <div className="flex-fill">
        <div className="row g-2 mb-3">
          <div className="col-12">
            <label htmlFor="Goal" className="form-label fs-12 fw-semibold mb-1">
              Goal
            </label>
            <input
              type="text"
              name="Goal"
              className="form-control form-control-sm"
              id="Goal"
              value={props.selectedGoal && props.selectedGoal.goal?.goal}
              disabled
            />
          </div>
          <div className="col-6">
            <label
              htmlFor="targetDate"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Due Date
            </label>
            <div className="mobiscroll">
              <div className="mobiscroll__calendar">
                <Datepicker
                  id="dueDate"
                  controls={["calendar"]}
                  calendarType="month"
                  theme="windows"
                  themeVariant="light"
                  placeholder="MM/DD/YYYY"
                  display="bubble"
                  touchUi={true}
                  buttons={[]}
                  defaultValue={props.selectedGoal?.dueDate}
                  value = {formatDateTask(goalForm.dueDate)}
                  showOnClick={false}
                  isOpen={openPicker}
                  onClose={() => {setOpenPicker(false)}}
                  min={ props.selectedGoal?.dueDate && new Date(props.selectedGoal?.dueDate) < new Date()
                    ? formatDateTask(props.selectedGoal?.dueDate)
                    : new Date() }
                  onChange={dateRangeChangeHandlar}
                  required
                />
              </div>
              <div onClick={() => setOpenPicker(!openPicker)} className="mobiscroll__calendar-icon">
                  <span className="material-symbols-outlined fs-18" >
                    calendar_month
                  </span>
              </div>
            </div>
          </div>
          <div className="col-6">
            <label
              htmlFor="status"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Status
            </label>
            <select
              className="form-select form-select-sm "
              name="status"
              value={goalForm.status}
              required
              onChange={(e) => handleUpdateGoal(e)}
            >
              {workflowStatus?.map((status:WorkflowState) => (
                <option key={status.stateId} value={status.stateId}>
                  {status.stateName}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="goalComment"
            className="form-label fs-12 fw-semibold mb-1"
          >
            Comments
          </label>
          <textarea
            name="goalComment"
            className="form-control form-control-sm"
            id="goalComment"
            placeholder="Type comments here..."
            rows={3}
            onChange={(e) => handleUpdateGoal(e)}
          ></textarea>
        </div>
      </div>

      <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
        <div>
          <button
            className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13"
            type="reset"
            onClick={handleDiscard}
          >
            Discard
          </button>
        </div>
        <div>
          <button
            className="btn btn-sm btn-secondary rounded-pill px-5 fs-13"
            type="submit"
          >
            Update
          </button>
        </div>
      </div>
    </Form>
  );
};
